import { useEffect, useState } from 'react';

export function useIsInViewport(ref, options) {
    const [isVisible, setIsVisible] = useState(false);

    const callback = (entries) => {
        const [entry] = entries;
        setIsVisible(entry.isIntersecting);
    };

    useEffect(() => {
        const target = ref.current;
        if (target) {
            const observer = new IntersectionObserver(callback, options);

            observer.observe(target);

            return () => observer.unobserve(target);
        }
    }, [ref, options]);

    return isVisible;
}
